import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import ModalTrigger from "../../Common/ModalTrigger";
import ButtonsSelect from "../../Common/ButtonsSelect";
import MultiLineChart from "../../Charts/MultiLineChart";
import csv2 from "../../../Data/EUMACP/Overview/EU-MACP-Overview-MRL-Exceedances-rate-comparison-2018-2021-2024-Line-chart.csv";
import { useState } from "react";

// import classes from '../../'

const FourthRow = () => {
  const aboveMRL = "Above MRL";
  const belowMRL = "Below or equal to MRL";
  const [mrlFilter, setMrlFilter] = useState("Above MRL");
  const handleMRLExceedanceButtonClick = (evt) => {
    if (evt === 0) {
      if (aboveMRL !== mrlFilter) {
        setMrlFilter(aboveMRL);
      }
    } else {
      if (belowMRL !== mrlFilter) {
        setMrlFilter(belowMRL);
      }
    }
  };

  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{
        marginTop: { xs: "50px", sm: "50px", md: "90px" },
        alignItems: { sm: "center", md: "center" },
        textAlign: { sm: "center", md: "left" },
      }}
      className="four-one-wrapper"
    >
      <Grid
        item
        xs
        p={3}
        className="four-one"
        sx={{ maxWidth: { md: "450px !important" } }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            width: "100%",
          }}
        >
          <h3>Comparison of MRL exceedance rates in 2018, 2021 and 2024</h3>
          <p className="paragraph">
            The EU MACP covers the most consumed food products in Europe. The listed products are distributed across a three-year cycle so that every three years the same products are analysed.
          </p>
          <p>A comparison between 2018 and 2024 results shows that the overall <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="MRL exceedance rate"
            />{" "} increased from 1.4% to 2.4%.</p>
        </Box>
      </Grid>
      <Grid item xs p={3} sx={{ width: "100%" }} className="four-two">
        <Box>
          <ButtonsSelect
            firstButton=">MRL"
            secondButton="≤MRL"
            onButtonClick={handleMRLExceedanceButtonClick}
          />
          <MultiLineChart
            legendPosition="right"
            title="MRL exceedance rate comparison (2017, 2020, 2023)"
            csv={csv2}
            filter={mrlFilter}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default FourthRow;
